import { IEducation } from "../interfaces/IEducation";

export const education: IEducation[] = [
  {
    institution: "University of Hull",
    degree: "Master of Science",
    field: "Artificial Intelligence",
    dates: "2024 – 2026",
  },
  {
    institution: "Bahrain Polytechnic",
    degree: "Bachelor of Science",
    field: "ICT – Programming",
    dates: "2015 – 2020",
  },
];
